interface NativeFaqListProps {
  faqs: Array<{ question: string; answer: string }>;
}

export function NativeFaqList({ faqs }: NativeFaqListProps) {
  return (
    <div className="space-y-3">
      {faqs.map((faq) => (
        <details key={faq.question} className="group rounded-xl border border-gray-100 bg-gray-50 px-6">
          <summary className="flex cursor-pointer items-center justify-between gap-4 py-5 text-left font-semibold text-primary">
            <span>{faq.question}</span>
            <span aria-hidden="true" className="text-accent text-xl leading-none transition-transform group-open:rotate-45">+</span>
          </summary>
          <p className="pb-5 text-muted-foreground leading-relaxed">{faq.answer}</p>
        </details>
      ))}
    </div>
  );
}